<script setup>
const sections = [
  {
    title: 'Verantwortlich für den Inhalt der Seiten:',
    texts: [
      'Raumpioniere AG',
      'Bahnhofstrasse 6',
      'CH-9000 St. Gallen'
    ]
  },
  {
    title: ' ',
    texts: [
      '+41 71 521 21 26',
      'hallo@raumpioniere.ch'
    ]
  },
  {
    title: ' ',
    texts: [
      'Unternehmens-Identifikationsnummer (UID):',
      'CHE-241.912.709'
    ]
  },
  {
    title: 'Copyright',
    texts: [
      'Das Copyright für sämtliche Inhalte dieser Website liegt bei Raumpioniere AG, St. Gallen.'
    ]
  },
  {
    title: 'Konzept und Technische Umsetzung',
    texts: [
      'Raumpioniere AG',
      'Bahnhofstrasse 6',
      'CH-9000 St. Gallen'
    ]
  },
  {
    title: 'Disclaimer',
    texts: [
      'Alle Texte und Links wurden sorgfältig geprüft und werden laufend aktualisiert. Wir sind bemüht, richtige und vollständige Informationen auf dieser Website bereitzustellen, übernehmen aber keinerlei Verantwortung, Garantien oder Haftung dafür, dass die durch diese Website bereitgestellten Informationen richtig, vollständig oder aktuell sind. Wir behalten uns das Recht vor, jederzeit und ohne Vorankündigung die Informationen auf dieser Website zu ändern und verpflichten uns auch nicht, die enthaltenen Informationen zu aktualisieren. Alle Links zu externen Anbietern wurden zum Zeitpunkt ihrer Aufnahme auf ihre Richtigkeit überprüft, trotzdem haften wir nicht für Inhalte und Verfügbarkeit von Websites, die mittels Hyperlinks zu erreichen sind. Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die durch Inhalte verknüpfter Seiten entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde. Dabei ist es gleichgültig, ob der Schaden direkter, indirekter oder finanzieller Natur ist oder ein sonstiger Schaden vorliegt, der sich aus Datenverlust, Nutzungsausfall oder anderen Gründen aller Art ergeben könnte.'
    ]
  },
  {
    title: ' ',
    texts: [
      'Raumpioniere AG',
      'Alle Rechte vorbehalten.'
    ]
  }
]
</script>

<template lang='pug'>
.full-width
  .routerPageSize
    .privacyContainer
      .header Impressum
      .sectionsContainer
        .section(v-for="(section, index) in sections" :key="index")
          .sectionTitle.sectionText(v-if="section.title") {{ section.title }}
          .column(v-if="section.texts")
            .sectionText(v-for="text in section.texts" :key="text") {{ text }}
</template>

<style lang='sass'>
.privacyContainer
  padding: 20px 0 60px 0
  .header
    @media screen and (min-width: 1024px)
      margin: 40px 0
      font-weight: 800
      font-size: 50px
      line-height: 130%
      color: #2F3849
    @media screen and (max-width: 1023px)
      font-weight: 700
      color: #2F3849
      font-size: 20px
      line-height: 130%
  .sectionsContainer
    margin: 20px 0
    .sectionTitle
      @media screen and (min-width: 1024px)
        padding: 40px 0 20px 0
      @media screen and (max-width: 1023px)
        padding: 20px 0 10px 0
    .sectionText
      @media screen and (min-width: 1024px)
        font-weight: 700
        font-size: 16px
        line-height: 130%
        color: #626C85
      @media screen and (max-width: 1023px)
        font-weight: 500
        font-size: 12px
        line-height: 130%
        color: #626C85
</style>
